import { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import api from '../../config/api';
import { setClients } from '../../features/createBudget/createBudgetSlice';

export default function useClientOptions() {
  const dispatch = useDispatch();
  const clients = useSelector(state => state.createBudget.clients);

  const [isClientsLoading, setIsClientsLoading] = useState(false);

  const toOptions = useCallback(
    items =>
      (items || []).map(item => ({
        value: item.id ?? item.value,
        label: item.name ?? item.label,
      })),
    [],
  );

  const clientOptions = useMemo(() => toOptions(clients), [clients, toOptions]);

  useEffect(() => {
    const fetchClients = async () => {
      setIsClientsLoading(true);
      try {
        const response = await api.GET_ALL_CLIENTS();
        const normalized = toOptions(response);
        dispatch(setClients(normalized));
      } finally {
        setIsClientsLoading(false);
      }
    };

    fetchClients();
  }, []);

  return {
    clientOptions,
    isClientsLoading,
  };
}
